import { LoadablePaint } from '@confluence/loadable';

export const LazySpaceDirectory = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SpaceDirectory" */ '../src/SpaceDirectory'))
			.SpaceDirectory,
});
